import * as Yup from 'yup';

export const costChargesValidationSchema = (
  isMedicalOrTravel: boolean,
  amendmentType: string
) => {
  const isCancellation = amendmentType === 'PolicyCancellation';

  return Yup.object().shape({
    chargesAndCost: Yup.object().shape({
      // Endorsement fields (only required for non-cancellation types)
      amendmentCost: Yup.number().when([], {
        is: () => !isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      }),

      chargesPercentage: Yup.number().when([], {
        is: () => !isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      }),

      newChargesPercentage: Yup.number().when([], {
        is: () => !isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      }),

      tpaFees: Yup.number().when([], {
        is: () => isMedicalOrTravel || isCancellation,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.typeError('Required').required('Required')
      }),

      newTPAFees: Yup.number().when([], {
        is: () => isMedicalOrTravel,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.typeError('Required').required('Required')
      }),

      // Cancellation-specific fields (only required for cancellation types)
      basicPremiumVariance: Yup.number().when([], {
        is: () => isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      }),

      chargesAmountVariance: Yup.number().when([], {
        is: () => isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      }),

      tpaFeesVariance: Yup.number().when([], {
        is: () => isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      }),

      cancellationCost: Yup.number().when([], {
        is: () => isCancellation,
        then: (schema) => schema.typeError('Required').required('Required'),
        otherwise: (schema) => schema.notRequired()
      })
    })
  });
};

export const costChargesCancellationValidationSchema = (
  showChargesFields = true
) => {
  return Yup.object().shape({
    chargesAndCost: Yup.object().shape({
      amendmentCost: Yup.number(),

      chargesPercentage: Yup.number(),

      newChargesPercentage: Yup.number(),

      tpaFees: showChargesFields
        ? Yup.number().typeError('Required').required('Required')
        : Yup.number().notRequired(),

      newTPAFees: Yup.number(),

      basicPremiumVariance: Yup.number()
        .typeError('Required')
        .required('Required')
        .when('basicPremium', ([basicPremium], schema) => {
          return schema
            .min(-(basicPremium ?? 0), 'Invalid Value')
            .max(0, 'Invalid Value');
        }),

      chargesAmountVariance: showChargesFields
        ? Yup.number()
            .typeError('Required')
            .required('Required')
            .when('chargesAmount', ([chargesAmount], schema) => {
              return schema
                .min(-(chargesAmount ?? 0), 'Invalid Value')
                .max(0, 'Invalid Value');
            })
        : Yup.number().notRequired(),

      tpaFeesVariance: showChargesFields
        ? Yup.number()
            .typeError('Required')
            .required('Required')
            .when('tpaFees', ([tpaFees], schema) => {
              return schema
                .min(-(tpaFees ?? 0), 'Invalid Value')
                .max(0, 'Invalid Value');
            })
        : Yup.number().notRequired(),

      cancellationCost: Yup.number().typeError('Required').required('Required')
    })
  });
};
